import React from 'react';

class MapErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: '' };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      errorMessage: error?.message || 'Terjadi error pada komponen peta.',
    };
  }

  componentDidCatch(error, info) {
    // Keep the app alive and log details for debugging.
    // eslint-disable-next-line no-console
    console.error('[MapErrorBoundary]', error, info);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.resetKey !== this.props.resetKey && this.state.hasError) {
      this.setState({ hasError: false, errorMessage: '' });
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[360px] rounded-xl border border-red-500/30 bg-red-950/20 p-6 text-red-100">
          <p className="text-base font-semibold">Halaman peta mengalami error.</p>
          <p className="mt-2 text-sm text-red-200/90">
            {this.state.errorMessage || 'Silakan muat ulang halaman untuk mencoba kembali.'}
          </p>
          <button
            type="button"
            onClick={this.handleReload}
            className="mt-4 rounded-md border border-red-300/40 bg-red-500/20 px-3 py-1.5 text-sm font-semibold text-red-100 hover:bg-red-500/30"
          >
            Muat Ulang Halaman
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default MapErrorBoundary;
